/**
 * Build a /patient-card path from a sales-header patient_id value.
 * Supports:
 * - PAT-000123 / PAT-PAT-000123 → ?patientId=123
 * - numeric id → ?patientId=N
 * - SHID: 15639 / SHID/86 → ?patientId=N (legacy free-text PK)
 * - SMC… / SHK… / GSHK… → ?patientNumber=… (legacy patient numbers)
 */
export function patientCardPath(patientIdField) {
  if (!patientIdField) return null;
  const raw = String(patientIdField).trim();
  if (!raw) return null;

  const patMatch = /^PAT-(?:PAT-)?(\d+)$/i.exec(raw);
  if (patMatch) {
    return `/patient-card?patientId=${Number(patMatch[1])}`;
  }
  if (/^\d+$/.test(raw)) {
    return `/patient-card?patientId=${raw}`;
  }

  // SHID values are free-text references to patients.patient_id, not patient_number.
  const shidMatch = /^SHID[:/\s]*(\d+)$/i.exec(raw);
  if (shidMatch) {
    return `/patient-card?patientId=${Number(shidMatch[1])}`;
  }

  // Legacy patient_number prefixes (normalize spaces/dashes; patients table is compact + uppercase).
  if (/^(SMC|GSHK|SHK)/i.test(raw)) {
    const normalized = raw.replace(/[\s-]/g, '').toUpperCase();
    return `/patient-card?patientNumber=${encodeURIComponent(normalized)}`;
  }

  return null;
}
